import { render, staticRenderFns } from "./RelationDynamicUserGroup.vue?vue&type=template&id=bf1c3aa6"
import script from "./RelationDynamicUserGroup.vue?vue&type=script&lang=js"
export * from "./RelationDynamicUserGroup.vue?vue&type=script&lang=js"
import style0 from "./RelationDynamicUserGroup.vue?vue&type=style&index=0&id=bf1c3aa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports